/* Compact presentation of the official app widget; all review data stays app-managed. */
(() => {
  'use strict';
  if (window.ivonneHeaderReviews) return;
  window.ivonneHeaderReviews = true;
  const compactCSS = `
    .widget.widget-rating{display:flex;align-items:center;justify-content:flex-start;gap:7px;width:max-content;max-width:100%;min-height:40px;padding:0;border:0;background:transparent;box-shadow:none;color:#193b2d;font-family:inherit;cursor:pointer}
    .widget-rating .stars-wrapper,.widget-rating .rating-divider{display:none}
    .widget-rating .logo-wrapper{order:-1;display:flex;align-items:center;justify-content:center;width:24px;min-width:24px;height:24px;padding:0;border:0;margin:0}
    .widget-rating .logo{width:24px;height:24px;padding:0;margin:0}
    .widget-rating .logo img{display:block;width:24px;height:24px;object-fit:contain}
    .widget-rating .reviews-wrapper{display:flex;align-items:baseline;gap:6px;white-space:nowrap;margin:0;padding:0}
    .widget-rating .rating{font-size:28px;line-height:1.2;font-weight:700;color:#193b2d}
    .widget-rating .reviews{display:none}
    .widget-rating .rating{display:inline-flex;align-items:center;gap:5px}
    .widget-rating .rating::before{content:'';width:24px;height:24px;flex:none;background:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23f5b301' d='M12 1.8l3.1 6.6 7.1.9-5.2 4.9 1.3 7.1L12 17.7l-6.3 3.6 1.3-7.1L1.8 9.3l7.1-.9z'/%3E%3C/svg%3E") center/contain no-repeat}
    .widget-rating:focus-visible{outline:2px solid #b44e2c;outline-offset:3px;border-radius:4px}
  `;
  function enhance(scope = document) {
    scope.querySelectorAll('.header-trust valued-widget').forEach(widget => {
      customElements.whenDefined('valued-widget').then(() => {
        function connect() {
          const root = widget.shadowRoot;
          if (!root) { requestAnimationFrame(connect); return; }
          function apply() {
            if (!root.querySelector('.widget-rating') || root.querySelector('[data-ivonne-compact]')) return;
            const style = document.createElement('style');
            style.dataset.ivonneCompact = '';
            style.textContent = compactCSS;
            root.append(style);
          }
          // The app renders asynchronously and can refresh its shadow tree later.
          new MutationObserver(apply).observe(root, { childList: true, subtree: true });
          apply();
        }
        connect();
      });
    });
  }
  enhance();
  document.addEventListener('shopify:section:load', event => enhance(event.target));
})();
